<template>
    <div class="footer mt-auto text-center w-100">
        <!-- <img src="/images/bee.png" style="height: 5rem;" class="mb-3 footer-bee" /> -->
        <span class="d-none d-lg-block p-2">&copy; ADBALU {{ year }}.</span>
        <div id="loader"><div><span class="rotating"></span><div>{{ $t('base.loading') }}</div></div></div>
        <div v-if="!isElectron() && !cookieConsentStart" id="gdpr-cookie-consent" :class="cookieConsent ? 'close' : ''">
            <div class="container d-flex flex-column flex-lg-row align-items-center">
                {{ $t('cookies_policy.question') }}
                <div class="mr-lg-0 ml-auto d-inline-flex mr-3 pt-2 pt-lg-0">
                    <a href="#" @click="agreeCookiesPolicy" class="gdpr-confirm btn btn-gdpr active mr-3">{{ $t('cookies_policy.agree_btn') }}</a> 
                    <a href="https://adbalu.com/cookies-policy" class="btn btn-gdpr">{{ $t('cookies_policy.read_more_btn') }}</a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue'

const Footer = Vue.component('footer-text', {
    data() {
        return {
            year: "2022",
            cookieConsent: localStorage.getItem("CookieConsent") === "true",
            cookieConsentStart: localStorage.getItem("CookieConsent") === "true",
        }
    },
    methods:{
        setYear () {
            let currentDate = new Date();
            this.year = currentDate.getFullYear();
        },
        agreeCookiesPolicy(){
            this.cookieConsent = true;
            localStorage.setItem("CookieConsent", true);
        }
    },
    mounted () {
        this.setYear();
    }
})

export default Footer
</script>